/**
 * A13 — live count for the sidebar's "Developer Access" badge
 * (= `GET /dev-access/requests?status=WAITING` length). Only runs when
 * `enabled` (the view shows the item), so a credit_officer or an LSP login
 * never calls the staff endpoint.
 */
import { useEffect, useState } from 'react';
import { devAccessApi } from './api';

export function useDevAccessRequestCount(enabled: boolean, refreshKey: string): number | null {
  const [count, setCount] = useState<number | null>(null);
  useEffect(() => {
    if (!enabled) return;
    let alive = true;
    devAccessApi
      .requests('WAITING')
      .then((rows) => { if (alive) setCount(rows.length); })
      .catch(() => {});
    return () => { alive = false; };
  }, [enabled, refreshKey]);
  return enabled ? count : null;
}
